// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34hl_","fullView":"styles_fullView__35rIa"};